import React, { useEffect, useState } from 'react';
import { Box, Button, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { postGetAllSeriesRequest } from '../services/actions';
import { Spinner } from '../../../common/Spinner/Spinner';
import styles from './SeriesInfoModal.module.scss';
import useModal from '../../../shared/hooks/useModal/useModal';
import { SeriesInnerModal } from './SeriesInnerModal';
import { seriesSelector } from '../services/selector';
import { getExcelFileSeriesRequest } from 'modules/EventsLog/SeriesReport/services/actions';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#ECEFF1 !important',
  boxShadow: 24,
  display: 'flex',
  p: 4,
  flexDirection: 'column',
};

interface Props {
  isShown: boolean;
  closeModal: () => void;
  series: any;
  dateParams: any;
  seriesDetailedParams: any;
}

export const SeriesInfoModal = ({ isShown, closeModal, series, dateParams, seriesDetailedParams }: Props) => {
  const dispatch = useDispatch();
  const { unreserveMarkingCode, seriesDetailed, modalLoading, detailedModalLoading } = useSelector(seriesSelector);
  const { isShow: isShowInner, openModal: openInnerModal, closeModal: closeInnerModal } = useModal();
  const [downloadDisabled, setDownloadDisabled] = useState(false);

  useEffect(() => {
    if (!modalLoading && !detailedModalLoading && !seriesDetailed) {
      closeModal();
      dispatch(postGetAllSeriesRequest(dateParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seriesDetailed]);

  useEffect(() => {
    if (!modalLoading && !detailedModalLoading && unreserveMarkingCode) {
      dispatch(postGetAllSeriesRequest(dateParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreserveMarkingCode]);

  const handleDownloadClick = () => {
    dispatch(
      getExcelFileSeriesRequest({
        series: seriesDetailedParams.series,
        gtin: seriesDetailedParams.gtin,
        countryCode: seriesDetailedParams.countryCode,
      }),
    );

    setDownloadDisabled(true);
    setTimeout(() => {
      setDownloadDisabled(false);
    }, 20000);
  };

  return (
    <div>
      <Modal
        open={isShown}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <span className={styles.responseText}>{unreserveMarkingCode ?? ''}</span>
          <div className={styles.spinnerWrapper}>{(modalLoading || detailedModalLoading) && <Spinner />}</div>
          <div className={styles.buttonsWrapper}>
            <CloseIcon onClick={closeModal} />
          </div>

          <div className={styles.mainButtonWrapper}>
            <Button
              variant="contained"
              className={styles.btn}
              onClick={openInnerModal}
              disabled={modalLoading || detailedModalLoading}
            >
              <span className={styles.btnText}>Передрукувати коди що не агрегувались</span>
            </Button>
          </div>
          <div className={styles.mainButtonWrapper}>
            <Button
              variant="contained"
              className={styles.btn}
              onClick={handleDownloadClick}
              disabled={modalLoading || detailedModalLoading || downloadDisabled}
            >
              <span className={styles.btnText}>{downloadDisabled ? 'Зачекайте' : 'Завантажити повний звіт'}</span>
            </Button>
          </div>
        </Box>
      </Modal>

      {isShowInner && (
        <SeriesInnerModal
          isShown={isShowInner}
          closeModal={closeInnerModal}
          params={{ series: series.series }}
          seriesDetailedParams={seriesDetailedParams}
        />
      )}
    </div>
  );
};
